export enum ELocalization {
    DYNAMIC_STRING = 'PERCENTAGE_STRING',
    DYNAMIC_INT = 'PERCENTAGE_INT',
    DYNAMIC_FLOAT = 'PERCENTAGE_FLOAT',
    DYNAMIC_FLOAT_2_DECIMAL = 'PERCENTAGE_FLOAT_2',
    DYNAMIC_LONG = 'PERCENTAGE_LONG',
}